import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import createMutationsSharer from "vuex-shared-mutations";
import jwt_decode from "jwt-decode";

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createMutationsSharer({ predicate: ["destroyToken", "saveToken", "changeLoginMessage", "saveAbilities", "destroyAbilities"] })],
  state: {
    token: localStorage.getItem('access_token') || null,
    expiry: localStorage.getItem('expiry') || null,
    refreshOn: parseInt(localStorage.getItem('refresh_on')) || null,
    loginMessage: 'Please login to use the site',
    loggedInUser: localStorage.getItem('loggedInUser') || null,
    loading: false,
    sidebarOpened: false,
    abilities: localStorage.getItem('abilities') || null
  },
  mutations: { // always sync - commit
    saveToken(state, payload) {

      const currentTimestamp =
        new Date(
          new Date().toLocaleString("en-us", { timeZone: "Asia/Jakarta" })
        ).getTime() / 1000;

      const refreshOn = (payload.expiry - currentTimestamp) * 0.25
      const jwtData = jwt_decode(payload.token);

      state.token = payload.token;
      state.expiry = payload.expiry;
      state.loggedInUser = jwtData.user;
      state.refreshOn = refreshOn;

      localStorage.setItem('loggedInUser', jwtData.user);
      localStorage.setItem('access_token', payload.token);
      localStorage.setItem('expiry', payload.expiry);

      localStorage.setItem('refresh_on', refreshOn);
    },
    saveAbilities(state, payload) {
      state.abilities = payload

      localStorage.setItem('abilities', payload)
    },
    destroyAbilities(state) {
      state.abilities = null
      
      localStorage.removeItem('abilities')
    },
    destroyToken(state) {
      state.token = null
      state.expiry = null
      state.refreshOn = null;
      state.loggedInUser = null;

      localStorage.removeItem('access_token');
      localStorage.removeItem('expiry');
      localStorage.removeItem('loggedInUser');
      localStorage.removeItem('refresh_on');
    },
    changeLoginMessage(state, text) {
      state.loginMessage = text;
    },
    toggleLoading(state) {
      if (state.loading) {
        state.loading = false;
      } else {
        state.loading = true;
      }
    },
    openSidebar(state) {
      state.sidebarOpened = true;
    },
    closeSidebar(state) {
      state.sidebarOpened = false;
    }
  },
  actions: { // can be async - dispatch
    login(context, credentials) {
      return new Promise((resolve, reject) => {
        axios.post(process.env.VUE_APP_API_URL + '/auth/login', credentials)
          .then(res => {
            if (res && res.status == 200) {
              const { data } = res.data
              const token = data.token
              const expiry = data.expiry
              const abilities = data.abilities.join()

              context.commit('saveToken', { token, expiry });
              context.commit('saveAbilities', abilities)

              axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
              resolve(res);
            }

            reject(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    logout(context) {
      if (context.getters.isLoggedIn) {
        return new Promise((resolve, reject) => {
          axios.post(process.env.VUE_APP_API_URL + '/auth/logout')
            .then(() => {
              resolve()
            })
            .catch(err => {
              reject(err)
            })
            .finally(() => {
              delete axios.defaults.headers.common['Authorization'];
              context.commit('destroyToken');
              context.commit('destroyAbilities')
            })
        })
      }
    },
    refresh(context) {
      return new Promise((resolve, reject) => {
        axios.get(process.env.VUE_APP_API_URL + '/auth/refresh')
          .then((res) => {
            // const token = res.data.data.token
            // const expiry = res.data.data.expiry

            // context.commit('saveToken', { token, expiry });
            // axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
            // resolve(res)

            const { data } = res.data
            const token = data.token
            const expiry = data.expiry
            const abilities = data.abilities.join()

            context.commit('saveToken', { token, expiry });
            context.commit('saveAbilities', abilities)

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
            resolve(res);
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  },
  getters: {
    isLoggedIn(state) {
      return state.token != null
    },
    getCoba(state) {
      return state.coba
    },
    getToken(state) {
      return state.token
    },
    getTokenExpiry(state) {
      return isNaN(parseInt(state.expiry)) ? 0 : parseInt(state.expiry)
    },
    getTokenRefreshOn(state) {
      return state.refreshOn
    },
    getLoginMessage(state) {
      return state.loginMessage
    },
    isLoading(state) {
      return state.loading
    },
    isSidebarOpened(state) {
      return state.sidebarOpened
    },
    getRole(state) {
      const tokenData = jwt_decode(state.token);

      return (tokenData.user) ? tokenData.role : ''
    },
    getAbilities(state) {
      return state.abilities
    },
    userCan: (state) => (privilege) => {
      if (state.abilities) {
        // if (typeof state.abilities === 'string') {
        return Object.values(state.abilities.split(",")).includes(privilege)
        // } else {
        //   const abilities = state.abilities
        //   return Object.values(abilities).includes(privilege)
        // }
      } else {
        return false
      }
    },
    getLoggedInUser(state) {
      return state.loggedInUser
    }
  }
})